
define("json!uikit/version.json", function () {
return {
  "version": "1.10.30"
}
;
});

